// generated from 939 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasBackgroundPushFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_background_push_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 411 (43.77%), defined 528 (56.23%)
  // true 522 (98.86%), false 6 (1.14%)
  raw_value: z.boolean().optional(),
  // true 932 (99.25%), false 7 (0.75%)
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
